import PageTopSection from './PageTopSection';

export default PageTopSection;
